import CollectionsIcon from '@mui/icons-material/Collections';
import { useState } from 'react';

import { SingleIconButton } from '@/shared/components/ui';
import { OrdenTrabajo } from '@/shared/interfaces';
import ValidateFotosEntradaOTActivacionModal from './ValidateFotosEntradaOTActivacionModal';
import ValidateFotosSalidaOTActivacionModal from './ValidateFotosSalidaOTActivacionModal';

export type ActivacionOTCellFotosPendingProps = {
  ordenTrabajo: OrdenTrabajo;
  canEdit?: boolean;
  isReviewingFotosEntrada?: boolean;
  isReviewingFotosSalida?: boolean;
};

const ActivacionOTCellFotosPending: React.FC<
  ActivacionOTCellFotosPendingProps
> = ({ ordenTrabajo, isReviewingFotosEntrada, isReviewingFotosSalida }) => {
  ///* local state ------------
  const [isOpenReviewImgEntradaModal, setIsOpenReviewImgEntradaModal] =
    useState(false);
  const [isOpenReviewImgSalidaModal, setIsOpenReviewImgSalidaModal] =
    useState(false);

  return (
    <>
      {/* ============ images review ============ */}
      {isReviewingFotosEntrada && (
        <SingleIconButton
          startIcon={<CollectionsIcon />}
          color="info"
          label={'Ver Fotos Entrada'}
          onClick={() => {
            setIsOpenReviewImgEntradaModal(true);
          }}
        />
      )}

      {isReviewingFotosSalida && (
        <SingleIconButton
          startIcon={<CollectionsIcon />}
          color="primary"
          label={'Ver Fotos Salida'}
          onClick={() => {
            setIsOpenReviewImgSalidaModal(true);
          }}
        />
      )}

      {/* ========= modals ========= */}
      <ValidateFotosEntradaOTActivacionModal
        ordenTrabajo={ordenTrabajo!}
        open={isOpenReviewImgEntradaModal && !!isReviewingFotosEntrada}
        onClose={() => {
          setIsOpenReviewImgEntradaModal(false);
        }}
      />

      <ValidateFotosSalidaOTActivacionModal
        ordenTrabajo={ordenTrabajo!}
        open={isOpenReviewImgSalidaModal && !!isReviewingFotosSalida}
        onClose={() => {
          setIsOpenReviewImgSalidaModal(false);
        }}
      />
    </>
  );
};

export default ActivacionOTCellFotosPending;
